/* @flow */
import * as React from 'react';
import classnames from 'classnames';

export type InputType = {
  type?: string,
  invalid?: boolean,
  descriptionId?: string,
  labelId?: string,
  errorId?: string,
  classNames?: string,
  name: string,
  id?: string,
};

const Input = ({
  type = 'input',
  invalid,
  descriptionId,
  labelId,
  errorId,
  classNames,
  name,
  id,
  ...rest
}: InputType) => {
  const attributes = {
    'aria-invalid': invalid && 'true',
    'aria-describedby': descriptionId,
    'aria-labelledby': labelId,
    'aria-errormessage': errorId,
    type,
    name,
    id: id || name,
  };
  const textarea = 'textarea';
  const inputClassNames = classnames(
    'input',
    type === textarea && textarea,
    classNames,
  );
  const HtmlTag = type === textarea ? textarea : 'input';

  return <HtmlTag {...rest} className={inputClassNames} {...attributes} />;
};

export default Input;
